import { isNewInboxTenant } from 'utils/tenant'

// Paleta NUEVA (rediseño STORE-170), convergente con Linear/Jira/GitHub Issues:
//   Nuevo → azul · En proceso → amber · Cancelado → gris · Finalizado → verde · Reabierto → naranja
const inventoryStatusColorNew = {
	0: { label: 'Nuevo', dotClass: 'bg-sky-500', textClass: 'text-sky-500' },
	1: { label: 'Nuevo', dotClass: 'bg-sky-500', textClass: 'text-sky-500' },
	2: { label: 'En proceso', dotClass: 'bg-[#f7a511]', textClass: 'text-amber-500' },
	3: { label: 'Cancelado', dotClass: 'bg-zinc-400', textClass: 'text-zinc-500' },
	4: { label: 'Finalizado', dotClass: 'bg-emerald-500', textClass: 'text-emerald-600' },
	5: { label: 'Borrado', dotClass: 'bg-zinc-400', textClass: 'text-zinc-500' },
	6: { label: 'Cerrado por sistema', dotClass: 'bg-emerald-300', textClass: 'text-emerald-500' },
	7: { label: 'Reabierto', dotClass: 'bg-orange-500', textClass: 'text-orange-500' },
}

// Paleta LEGACY (pre-STORE-170): la que ve Movistar y tenants no migrados.
const inventoryStatusColorLegacy = {
	0: { label: 'Nuevo', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
	1: { label: 'Nuevo', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
	2: { label: 'En proceso', dotClass: 'bg-[#f7a511]', textClass: 'text-amber-500' },
	3: { label: 'Cancelado', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	4: { label: 'Cerrado', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	5: { label: 'Borrado', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	6: { label: 'Cerrado por sistema', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	7: { label: 'Reabierto', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
}

const resolvePalette = () => (isNewInboxTenant() ? inventoryStatusColorNew : inventoryStatusColorLegacy)

// Tenant-dependiente: cubre los ~17 consumidores (tabla, Home, notificaciones Pusher)
// sin tocarlos uno por uno, porque todos lo usan igual: `inventoryStatusColor[id]`.
//
// Proxy y no un ternario evaluado al importar: en los tenants en convivencia el usuario
// cambia de vista sin recargar la página, y una constante congelada dejaría los chips de
// estado con los colores de la vista con la que arrancó la sesión. Resolver en cada
// acceso los deja siempre en la paleta que corresponde.
//
// Los cuatro traps son necesarios: con solo `get`, un `Object.keys()`, un spread o un
// `in` sobre esto contestaría por el target y no por la paleta viva. Hoy las dos tienen
// las mismas claves, así que `has` no cambia ninguna respuesta, pero si alguna paleta
// suma un estado que la otra no tiene, el `in` empieza a mentir en silencio.
export const inventoryStatusColor = new Proxy(inventoryStatusColorNew, {
	get: (target, key) => resolvePalette()[key],
	has: (target, key) => key in resolvePalette(),
	ownKeys: () => Reflect.ownKeys(resolvePalette()),
	getOwnPropertyDescriptor: (target, key) => {
		const descriptor = Object.getOwnPropertyDescriptor(resolvePalette(), key)
		// `configurable: true` es obligación del invariante de Proxy: sin esto, iterar
		// las claves tira TypeError.
		return descriptor && { ...descriptor, configurable: true }
	},
})

export const priorityStatusColor = {
	0: { label: 'Sin prioridad', dotClass: 'bg-zinc-500', textClass: 'text-zinc-500' },
	1: { label: 'Alta', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	2: { label: 'Media', dotClass: 'bg-[#f7a511]', textClass: 'text-amber-500' },
	3: { label: 'Baja', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
}


export const deviceStatusColor = {
	0: { label: 'false', dotClass: 'bg-red-500', textClass: 'text-red-500' },
	1: { label: 'true', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
}


export const menuManageList = [
	{
		key: 'users',
		path: '/manage/users',
		title: 'Users',
		translateKey: 'nav_users',
		icon: 'users',
		authority: [],
		subMenu: []
	},
	{
		key: 'teams',
		path: '/manage/teams',
		title: 'Teams',
		translateKey: 'nav_teams',
		icon: 'teams',
		authority: [],
		subMenu: []
	},
	{
		key: 'channels',
		path: '/manage/channels',
		title: 'Channels',
		translateKey: 'nav_channels',
		icon: 'channels',
		authority: [],
		subMenu: []
	},
	{
		key: 'issue_type',
		path: '/manage/issuetype',
		title: 'Stores',
		translateKey: 'nav_issue_type',
		icon: 'issue_type',
		authority: [],
		subMenu: []
	},
	{
		key: 'stores',
		path: '/manage/stores',
		title: 'Stores',
		translateKey: 'stores_alias',
		icon: 'store',
		authority: [],
		subMenu: []
	},
	{
		key: 'devices',
		path: '/manage/devices',
		title: 'Devices',
		translateKey: 'nav_devices',
		icon: 'devices',
		authority: [],
		subMenu: []
	},
	{
		key: 'partners',
		path: '/manage/partners',
		title: 'Partners',
		translateKey: 'nav_partners',
		icon: 'store',
		authority: [],
		subMenu: []
	},

	{
		key: 'roles',
		path: '/manage/roles',
		title: 'Roles',
		translateKey: 'nav_roles',
		icon: 'home',
		authority: [],
		subMenu: []
	},


]